const Footer = () => {
  return (
    <footer className="bg-green-600 text-white py-3">
      <div className="container mx-auto px-4 text-center">
        <p>© 2025 All Rights Reserved Grace Super Market</p>
      </div>
    </footer>
  );
};

export default Footer;